import {Injectable, OnDestroy} from "@angular/core";
import {Logentry} from "./logentry.model";
import {BaselogService, LogRequest} from "../core/base-api";
import {Subscription} from "rxjs";
import {CapiLoginService} from "../core/extension/login/capi-login-service";

/**
 * @whatItDoes: Send logs and errors to the Server, where they can be logged centrally
 */
@Injectable()
export class ServerLoggerService implements OnDestroy {

  private subscription: Subscription;

  constructor(private service: BaselogService, public loginService: CapiLoginService) {
  }

  log(entries: Logentry[]) {
    if (this.loginService.userLoggedIn) {
      this.subscription = this.service.log(entries.map(this.convert)).subscribe({
        next: (data) => {
          this.responseAction(data);
        }, error: (err) => {
          if (err?.status === 401) {
            // don't throw 401 from logging to global error handler (which navigates to unauthorized page)
          } else {
            throw err;
          }
        }
      });
    }
  }

  private convert(entry: Logentry): LogRequest {
    return {
      message: entry.message,
      level: entry.level,
      optionalArguments: entry.parameters.map(e => JSON.stringify(e)),
      stack: entry.stack,
    };
  }

  private responseAction(data) {
    console.log('Received Log-Response from Server UUID: ' + data.uid + ' DateTime: ' + data.loggedDateTime);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

}
